import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface TooltipProps {
  content: string;
  children: React.ReactNode;
  delay?: number;
  position?: 'top' | 'left' | 'right' | 'bottom';
}
export function Tooltip({
  content,
  children,
  delay = 300,
  position = 'top'
}: TooltipProps) {
  const [isVisible, setIsVisible] = useState(false);
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null);
  const showTooltip = () => {
    const id = setTimeout(() => {
      setIsVisible(true);
    }, delay);
    setTimeoutId(id);
  };
  const hideTooltip = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      setTimeoutId(null);
    }
    setIsVisible(false);
  };
  const positionClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2'
  };
  const arrowClasses = {
    top: 'absolute top-full left-1/2 -translate-x-1/2',
    left: 'absolute left-full top-1/2 -translate-y-1/2',
    right: 'absolute right-full top-1/2 -translate-y-1/2',
    bottom: 'absolute bottom-full left-1/2 -translate-x-1/2'
  };
  const arrowBorder = {
    top: 'w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-slate-800',
    left: 'w-0 h-0 border-t-4 border-b-4 border-l-4 border-transparent border-l-slate-800',
    right: 'w-0 h-0 border-t-4 border-b-4 border-r-4 border-transparent border-r-slate-800',
    bottom: 'w-0 h-0 border-l-4 border-r-4 border-b-4 border-transparent border-b-slate-800'
  };
  const initialAnim = {
    top: {
      opacity: 0,
      y: 5,
      scale: 0.95
    },
    left: {
      opacity: 0,
      x: 5,
      scale: 0.95
    },
    right: {
      opacity: 0,
      x: -5,
      scale: 0.95
    },
    bottom: {
      opacity: 0,
      y: -5,
      scale: 0.95
    }
  };
  return <div className="relative inline-flex" onMouseEnter={showTooltip} onMouseLeave={hideTooltip} data-id="element-2749">
      {children}
      <AnimatePresence data-id="element-2750">
        {isVisible && <motion.div initial={initialAnim[position]} animate={{
        opacity: 1,
        x: 0,
        y: 0,
        scale: 1
      }} exit={initialAnim[position]} transition={{
        duration: 0.15,
        ease: 'easeOut'
      }} className={`absolute ${positionClasses[position]} pointer-events-none z-[9999]`} data-id="element-2751">
            <div className="px-2.5 py-1.5 bg-slate-800 text-white text-xs font-medium rounded shadow-xl whitespace-nowrap border border-white/10" data-id="element-2752">
              {content}
            </div>
            <div className={arrowClasses[position]} data-id="element-2753">
              <div className={arrowBorder[position]} data-id="element-2754" />
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}